
export function isMobile (){
  return window.innerWidth < 900;
}

export const isProd = process.env.REACT_APP_ENV === 'prod';

export function change24HourTo12 (time: string){
  const hour = parseInt(time.substring(0,2));
  const minutes = time.substring(3,5);

  let reformatedtime;
  if(hour >= 12){
    reformatedtime = (hour === 12 ? "12" : hour - 12) + ":" + minutes + " PM";
  }else{
    reformatedtime = (hour === 0 ? "12" : hour) + ":" + minutes + " AM";
  }
  return reformatedtime;
}
